export default "__VITE_ASSET__7724c152__"